import { FieldChoice } from '../types';
import AdjustRule from './adjust-rule';
import OrderRule from './order-rule';

interface GetRuleInfo {
    categoryId: number;
    marketType: FieldChoice[];
    aatPAccounts: string[];
    aatCategoryAcct: (string | number)[];
    delivery: FieldChoice[];
}

function getRule (info: GetRuleInfo) {
    const { categoryId, marketType, aatPAccounts, aatCategoryAcct, delivery } = info;
    switch (categoryId) {
        case 1: return AdjustRule(marketType);
        case 2: return OrderRule(marketType, aatPAccounts, aatCategoryAcct, delivery);
        default: return null;
    }
}

function useDynamicRule () {
    const validator = (r: any) => !!r.value || r.value.lenght > 0;

    const getRuleInfo = (getName: any, getColumnDefs: any, getConditionFields: any, getActionFields: any, initialState: any, dlgStyles?: any) => ({
        name: getName(),
        columnDefs: getColumnDefs(),
        conditionFields: getConditionFields(),
        actionFields: getActionFields(),
        initialState: initialState || {}, // For dataGrid
        dlgStyles: dlgStyles || {}
    });

    const showMarket = (value: any) => {
        switch (value) {
            case 1: return 'VV';
            case 2: return 'TN';
            case 3: return 'SH';
            case 4: return 'SG';
            case 13: return 'GC';
            default: return 'TP';
        }
    };

    return { validator, showMarket, getRuleInfo };
}

export {
    useDynamicRule,
    getRule
};